import { ROUTE_KEY_BUY, ROUTE_KEY_HOME, ROUTE_KEY_HOME_SEARCH } from '../../../constants/routes'
import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { selectHomeData } from '../../../store/selectors/home'
import { Icon, LinkButton, Box, Text, Flex } from '@homebotapp/hb-react-component-catalog'
import { selectRouteKey } from '../../../store/selectors/routes'
import { GLOBAL_AGENT_NAVIGATION } from '../../../constants/tracking/trackingEventLocations/globalTrackingEventLocation'
import { selectCustomerFirstName, selectName } from '../../../store/selectors/customerProfile'
import useViewport from '../../../hooks/useViewport'
import { Banner } from '../Banner/Banner'
import { selectBuyerId } from '../../../store/selectors/buyerInfo'
import { useLocation } from 'react-router'
import { selectClientId } from '../../../store/selectors/client'

export const MSG = defineMessages({
  back: {
    id: 'Navigation.customerProfile.backToClient',
    defaultMessage: 'Back to client'
  },
  previewingAs: {
    id: 'Navigation.customerProfile.previewingAs',
    defaultMessage: 'Previewing as'
  }
})

export const ImpersonationBanner = () => {
  const intl = useIntl()

  const { isLargeOrAbove } = useViewport()

  const home = useSelector(selectHomeData)
  const buyerId = useSelector(selectBuyerId)
  const clientId = useSelector(selectClientId)
  const customerName = useSelector(selectName)
  const customerFirstName = useSelector(selectCustomerFirstName)
  const name = isLargeOrAbove ? customerName : customerFirstName

  const routeKey = useSelector(selectRouteKey)
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const impId = params.get('impId')
  let backLink = ''
  const baseUrl = process.env.REACT_APP_CUSTOMER_ADMIN_URI
  if (impId) {
    backLink = `${baseUrl}/clients/${impId}`

    if (routeKey === ROUTE_KEY_BUY || routeKey === ROUTE_KEY_HOME_SEARCH) {
      backLink += `/buying`
    } else if (home?.id && routeKey === ROUTE_KEY_HOME) {
      backLink += `/homes`
    }
  } else {
    if (clientId && home?.id && routeKey === ROUTE_KEY_HOME) {
      backLink = `${baseUrl}/clients/${clientId}/homes`
    } else if (buyerId && (routeKey === ROUTE_KEY_BUY || routeKey === ROUTE_KEY_HOME_SEARCH)) {
      backLink += `${baseUrl}/clients/${buyerId}/buying`
    } else {
      backLink += `${baseUrl}/clients`
    }
  }

  return (
    <Banner display='flex' justifyContent='space-between' alignItems='center' pl='2' pr='6'>
      <LinkButton
        variant='ghost'
        size='xs'
        color='white'
        href={backLink}
        leftIcon={<Icon name='angle-left' />}
        tracking={{
          guid: 'sKhBfRLvx7kVW7j5QoHgYj',
          ui_context: GLOBAL_AGENT_NAVIGATION,
          descriptor: MSG.back.defaultMessage
        }}
      >
        {intl.formatMessage(MSG.back)}
      </LinkButton>
      <Flex alignItems='baseline'>
        <Text size='3xs' as='span' color='white'>
          {intl.formatMessage(MSG.previewingAs)}
        </Text>
        &nbsp;
        <Text as='span' fontWeight='semibold' size='3xs' color='white'>
          {name}
        </Text>
      </Flex>
    </Banner>
  )
}
